/**
 * GraphQL type definitions matching backend schema — dataDomain pillar.
 * Split from graphql/types.ts (issue #1409).
 */

import type { PageInfo } from './common';

export enum DataDomainType {
  Master = 'master',
  Reference = 'reference',
  Transactional = 'transactional',
  Analytical = 'analytical',
  Metadata = 'metadata',
}

export enum DataClassification {
  Public = 'public',
  Internal = 'internal',
  Confidential = 'confidential',
  Restricted = 'restricted',
}

export enum DataLifecycleStatus {
  Planned = 'planned',
  Developing = 'developing',
  Active = 'active',
  Mature = 'mature',
  Deprecated = 'deprecated',
  Retired = 'retired',
}

export enum DataCriticalityLevel {
  Critical = 'critical',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export interface DataDomain {
  entityId: string;
  entityType: string;
  name: string;
  description?: string | null;
  domainType: DataDomainType;
  dataStewardId: string;
  owningBusinessUnitId: string;
  technicalOwnerId?: string | null;
  defaultClassification: DataClassification;
  containsPII: boolean;
  containsPCI: boolean;
  containsPHI: boolean;
  complianceFrameworks?: string[] | null;
  retentionPeriodDays?: number | null;
  qualityScore?: number | null;
  lifecycleStatus: DataLifecycleStatus;
  criticalityLevel: DataCriticalityLevel;
  tags?: string[] | null;
  notes?: string | null;
  documentationUrl?: string | null;
  _schemaVersion: string;
  _createdAt: string;
  _createdBy: string;
  _updatedAt: string;
  _updatedBy: string;
  _deletedAt?: string | null;
}

export interface DataDomainEdge {
  node: DataDomain;
  cursor: string;
}

export interface DataDomainConnection {
  edges: DataDomainEdge[];
  pageInfo: PageInfo;
  totalCount?: number | null;
}

export interface DataDomainFilter {
  domainType?: DataDomainType;
  defaultClassification?: DataClassification;
  lifecycleStatus?: DataLifecycleStatus;
  criticalityLevel?: DataCriticalityLevel;
  dataStewardId?: string;
  includeDeleted?: boolean;
}
